import { useLang } from "@/i18n/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FaqSection() {
  const { t } = useLang();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="container-x scroll-mt-24 py-24 md:py-32"
    >
      <div className="grid grid-cols-1 gap-12 md:grid-cols-[0.7fr_1fr]">
        <div>
          <span className="overline" data-testid="faq-overline">{t.faq.overline}</span>
          <h2 className="mt-4 text-4xl text-zinc-900 md:text-[52px] md:leading-[1.05]">
            {t.faq.title}
          </h2>
        </div>
        <div className="rounded-3xl border border-zinc-200 bg-white">
          <Accordion type="single" collapsible defaultValue="item-0">
            {t.faq.items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-zinc-200 px-6 last:border-b-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-left text-base font-medium text-zinc-900 hover:no-underline">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-zinc-600">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
